import { useQuery } from "@tanstack/react-query"
import { getIntention } from "../services/intention.service"

export function useIntention(slug: string) {
  const { data, isLoading, error, refetch } = useQuery({
    queryKey: ["intention", slug],
    queryFn: () => getIntention(slug),
    enabled: !!slug,
    staleTime: 5 * 60 * 1000,
  })

  return {
    intention: data ?? null,
    isLoading,
    error,
    refetch,
  }
}
